var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 647,
    height: 856,
    viewBox: "0 0 647 856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "49.998%",
    x2: "49.998%",
    y1: "108.397%",
    y2: "-18.883%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C1B8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#E1DDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78%",
    stopColor: "#F7F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "51.533%",
    x2: "37.482%",
    y1: "209.03%",
    y2: "-95.339%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C1B8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "19%",
    stopColor: "#D3CDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#EBE8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77%",
    stopColor: "#FAF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "98%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M273.759 23.225c37.418-25.608 73.366-24.94 124.867-21.493.688.037 1.37.154 2.03.349l2.861.81c.88.238 1.758.445 2.654.62 36.203 7.291 111.6 36.14 133.786 73.932 7.129 10.532 15.025 34.106 17.902 49.452 4.667 36.537 5.467 61.001-5.243 95.314-6.265 20.096-16.192 37.904-23.432 57.443a225.676 225.676 0 0 0-13.667 72.47c-.56 22.368 2.19 45.053 9.303 65.434 4.7 13.487 11.189 25.75 17.694 37.92 25.75 48.26 30.146 64.575 47.361 118.84 14.386 45.259 12.148 65.735 5.53 113.567-4.49 32.439-55.016 71.486-71.928 73.281-98.381 6.672-66.893-30.977-174.673 39.015-155.669 90.549-291.373-28.832-294.858-93.9-3.484-65.068 9.99-110.422 9.015-146.784C61.203 497.54-1.359 445.595.096 383.64c1.454-61.954 3.74-80.715 17.966-124.623 18.318-56.57 56.727-84.354 82.542-90.835 25.814-6.481 52.843-8.53 75.412-47.959 0 0 7.8-42.383 97.743-96.998z",
    opacity: 0.75,
    transform: "translate(26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M42.668 6.936C31.647.08 17.477 6.761 10.281 18.44 3.086 30.116 1.26 45.309.834 59.803c-.503 16.975.646 34.714 7.684 49.653 7.038 14.94 21.224 26.33 35.41 23.864 13.13-2.338 23.129-15.91 27.128-30.832 3.999-14.923 3.07-31.135 1.574-46.805-1.354-14.605-3.353-29.926-11.021-41.667C53.94 2.275 39.015-4.073 28.844 4.121",
    opacity: 0.75,
    transform: "translate(564 290)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4738A7",
    d: "M475.22 522c.53 10.125 7.78 225 7.78 225l-29.78-2.618L413 619.995s16.181-94.79 17.302-94.551c5.352 1.38 34.618-1.54 44.918-3.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5648B6",
    d: "M441 528.881l-50.295 199.336-42.76.783s-2.127-225 0-225c22.606 9.444 66.99 19.943 93.055 24.881z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M491.821 365.318c3.786 1.619 23.964 18.635 32.511 29.822 6.39-4.776 78.634-65.586 80.088-68.954 2.86-1.62 8.963 7.658 0 15.251 6.103-.226 42.177-1.165 42.177 0 0 1.166 7.796 4.55-45.18 13.163-6.998 8.597-70.678 84.4-81.015 84.4-10.336 0-52.53-41.48-54.318-48.927-1.79-7.448 25.737-24.755 25.737-24.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7B6FC",
    d: "M436.83 332.516c-16.44 15.015 13.661 60.295 22.239 62.262 10.833 2.56 35.55-17.59 40.855-31.545 2.335-6.57-49.576-43.016-63.093-30.717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD45C",
    d: "M407.145 310c-90.313 0-69.81 177.04-64.05 189.14 3.14 6.6 39.011 20.055 72.417 29.397l3.689 1.005c1.743.478 3.454-2.36 5.165-1.913 24.332 6.377 45.525-1.706 49.261-5.548C482.732 512.595 499.513 310 407.145 310z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7C7FD",
    d: "M387.918 310v16.6s.955 47.907 12.1 80.837a667.983 667.983 0 0 1 3.188 105.388S400.019 526 392.059 526c-7.96 0-20.014-3.983-20.014-3.983L330 509.527l23.601-175.996c8.038-12.172 20.352-20.616 34.317-23.531z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M424 286h-26v41.97c0 5.373 26 5.373 26 0V286z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.5,
    cy: 253,
    fill: "#F7BDAD",
    rx: 28.5,
    ry: 48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B098E3",
    d: "M291.338 478.244l74.765-5.203 6.936 98.511-74.764 5.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7B6FC",
    d: "M300.503 482.583l74.556-5.547 7.396 98.237-74.556 5.547z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 336,
    cy: 558,
    fill: "#FBB5A9",
    rx: 14,
    ry: 21
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M328.955 385c-1.872 4.247-14.208 51.777-11.593 92.387 2.616 40.61 9.427 63.48 9.427 66.672 0 3.193 22.891 1.903 22.891 0s-5.912-59.688-4.643-69.943c1.27-10.255 18.403-69.66 17.954-76.958-.449-7.298-34.036-12.158-34.036-12.158z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7B6FC",
    d: "M362.234 334.621c-20.813-6.506-45.427 40.042-43.078 48.109 2.98 10.169 32.025 21.218 46.579 18.978 6.859-1.113 13.576-61.662-3.5-67.087z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B098E3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M360.988 485.714a4.942 4.942 0 0 1-4.542 5.275 4.94 4.94 0 0 1-5.25-4.55l-1.185-16.17a4.942 4.942 0 0 1 4.526-5.258 4.94 4.94 0 0 1 5.25 4.533l.641 8.604"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B098E3",
    d: "M392.462 310l-9.88 3.298L376 336.527l11.522 8.276-8.24 6.628S394.12 374.596 404 411c-1.657-28.192-11.538-66.26-11.538-101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7C7FD",
    d: "M425.218 313v16.6s-.963 47.907-12.195 80.837a659.956 659.956 0 0 0-3.215 105.404S413.023 529 421.055 529 463 354.645 463 354.645 448.661 317.668 425.218 313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B098E3",
    d: "M426.538 312l9.88 3.316 6.582 23.18-11.538 8.281 8.24 6.616S424.88 376.573 415 413c1.641-28.145 11.538-66.223 11.538-101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7C7FD",
    d: "M424 527.36s43.753 6.551 51.858-6.535c1.567-3.275 19.438-73.594-8.105-166.825"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7B6FC",
    d: "M426.554 481s-4.983 28 14.946 28 14.946-28 14.946-28c-9.562 3.745-20.33 3.745-29.892 0zM393 311.087l2-1.087v4.935L393 316v-4.652M429.776 316L424 314.58V310l6 1.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B098E3",
    d: "M446 371h6v22h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B098E3",
    d: "M438 385v-6h22v6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D163D",
    d: "M462.178 233.871c-1.887-6.286-8.943-11.708-12.242-19.315-1.68-3.85-5.645-20.778-11.306-25.241-11.718-9.21-15.856-5.39-22.913-6.287-12.32-1.571-18.885-8.062-27.892-5.39-10.227 3.033-12.479 10.545-19.805 12.714-8.388 2.483-16.618 0-28.383 3.442-6.343 1.87-11.544 14.004-8.96 22.57 6.121 20.258 21.17 12.572 22.644 17.523 1.03 3.426.904 6.46 2.315 11.127 1.855 6.161 9.673 7.702 13.542 6.554 11.766-3.489 12.78-5.658 12.78-5.658a67.087 67.087 0 0 1 4.313-17.76c.302-.707 9.832 3.364 22.438.19 10.338-2.641 18.235-2.437 19.932 3.221 1.22 3.992 3.536 16.172 4.63 19.457 1.094 3.285 2.711 5.155 3.346 4.982a9.41 9.41 0 0 1 4.582-2.546c4.202-1.257 6.343 4.715 7.104 4.542 4.234-1.241 18.204-9.87 13.875-24.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7B6FC",
    d: "M231 580h385a232.27 232.27 0 0 0-1.387-5.248c-2.328-8.449-4.354-15.926-6.235-22.752H231v28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F0FD",
    d: "M254 833.358c38.519 3.175 81.607-5.11 126.392-31.983 104.31-69.935 73.834-32.317 169.052-38.983 16.309-1.857 65.235-40.808 69.582-73.284 6.14-45.84 8.345-66.57-3.76-108.108H254v252.358z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M113 814h26v20h-26zM188 819h26v20h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4738A7",
    d: "M111 470v347h28.822l33.113-185.716S177.466 530.889 111 470z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5648B6",
    d: "M207.261 464.474C208.057 474.47 218 656.273 218 656.273V821.81L188.648 825l-18.884-176.046L113 471.346c8.59-4.783 71.48-13.68 94.261-6.872z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD45C",
    d: "M155.18 313c60.33 0 63.248 213.675 56.015 226.524-7.233 12.848-92.99 21.595-100.872 10.193C102.441 538.315 80.013 313 155.18 313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D163D",
    d: "M190 836v20h57v-7.283L217.353 836zM113 830v20h57v-7.283L140.353 830z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M158 325.27c0 4.696-22 5.244-22 0v-44.783L158 279v46.27zM136.022 402.392c.317 4.196-.158 55.167 7.113 76.37 7.27 21.202 39.602 48.801 45.083 59.188 7.05 13.46 5.814 15.043 12.292 21.757 3.47 3.594 14.78 4.434 17.774 1.583 2.994-2.85 8.918-10.355 0-22.833-9.014-7.347-48.71-58.287-49.582-68.294-.871-10.007 5.37-72.173 4.261-76.401-1.109-4.228-38.002-5.146-36.94 8.63z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.5,
    cy: 269,
    fill: "#F7BDAD",
    rx: 5.5,
    ry: 7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74C",
    d: "M150.787 330.005c17.715-.69 33.993 69.095 26.221 72.683-7.771 3.588-46.354 5.643-50.943-1.242-4.59-6.885 6.027-70.736 24.722-71.44z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.5,
    cy: 263.5,
    fill: "#F7BDAD",
    rx: 25.5,
    ry: 46.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D163D",
    d: "M51.387 208.958c19.648 0 35.78 13.877 56.94 13.877 15.113 0 29.718-17.835 50.909-17.835C186.44 205 195 219.362 195 229.28c0 7.916-5.043 16.833-6.555 16.833 0-2.471-3.022-11.389-4.025-12.374-1.002 3.457-22.161 27.737-40.807 27.737v.078c-2.834-1.863-6.634-1.371-8.882 1.15a6.597 6.597 0 0 0 0 8.809c2.248 2.52 6.048 3.012 8.882 1.149v14.502h-5.06c-6.554 0-9.545-2.472-19.647-2.472-17.643 0-42.319 21.308-72.546 21.308C13.602 306 0 281.72 0 254.483c0-36.107 34.762-45.525 51.387-45.525z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8852CC",
    d: "M479.527 140h74.946c13.548.009 24.527 10.758 24.527 24.016-.018 13.245-10.99 23.975-24.527 23.984h-74.946c-13.536-.009-24.51-10.74-24.527-23.984-.013-6.37 2.567-12.484 7.169-16.99 4.602-4.506 10.848-7.034 17.358-7.026z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8852CC",
    d: "M483 175.992L461 155v42z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 164,
    r: 7,
    fill: "#FED385"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 164,
    r: 7,
    fill: "#FED385"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542,
    cy: 164,
    r: 7,
    fill: "#FED385"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBCDFD",
    d: "M387 636h28v98h-28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBCDFD",
    d: "M351.5 699.5v-28h99v28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero4);
export default __webpack_public_path__ + "static/media/hero-4.8e429074af3e8d3ee41c70239f59733a.svg";
export { ForwardRef as ReactComponent };